import { styled } from '@mui/system';
import { Button } from '@mui/material';

const UserProfileFollowState = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  lineHeight: '30px',
  marginRight: '8px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '15px',
    lineHeight: '18px',
  },
}));

const FollowBtnContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '18px',
  paddingTop: '2px',
});

const FollowButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'followState',
})(({ followState, theme }) => ({
  color: followState ? '#AB9178' : '#000000',
  fontSize: '18px',
  height: '30px',
  lineHeight: '30px',
  fontWeight: 600,
  border: 'none',
  '& span': {
    color: followState ? '#AB9178' : '#000000',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '15px',
    lineHeight: '18px',
    height: '21px',
    fontWeight: 400,
  },
}));

const UserFollowBtn = (props) => {
  return (
    <>
      <FollowBtnContainer>
        <FollowButton
          followState={props.followState}
          onClick={props.handleClick}
          disabled={!props.currentUser && !props.isLogin}
        >
          <UserProfileFollowState>&diams;</UserProfileFollowState>
          {props.followState ? 'Following' : 'Follow'}
        </FollowButton>
      </FollowBtnContainer>
    </>
  );
};

export default UserFollowBtn;
